var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 2.49993H15C17.7614 2.49993 20 4.73851 20 7.49993V14.0624L11.25 14.0624C10.7322 14.0624 10.3125 14.4822 10.3125 14.9999C10.3125 15.5177 10.7322 15.9374 11.25 15.9374L20 15.9374V22.4999C20 25.2614 17.7614 27.4999 15 27.4999H8.75C5.98858 27.4999 3.75 25.2614 3.75 22.4999V19.9999V9.99993V7.49993C3.75 4.73851 5.98858 2.49993 8.75 2.49993ZM20 15.9374L25.2367 15.9374L23.0871 18.087C22.721 18.4531 22.721 19.0467 23.0871 19.4128C23.4532 19.779 24.0468 19.779 24.4129 19.4128L27.279 16.5467C28.1333 15.6925 28.1333 14.3074 27.279 13.4531L24.4129 10.587C24.0468 10.2209 23.4532 10.2209 23.0871 10.587C22.721 10.9531 22.721 11.5467 23.0871 11.9128L25.2367 14.0624L20 14.0624V15.9374Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/Logout.2bf1baef3fde8c20bc7bc5bc937741b4.svg";
export { ForwardRef as ReactComponent };